import React, { useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useIdleTimer } from 'react-idle-timer';
import { setItemToStore } from '../helpers/utils';
import AppContext from '../context/Context';
import InactivityScreen from './auth/basic/InactivityScreen';

const SESSION_TIMEOUT     = 10 * 60 * 1000; // 10 minutes — logged-in users
const SLIDESHOW_TIMEOUT   = 30 * 1000;       // 30 seconds — guru login page
const DISABLED_TIMEOUT    = 24 * 60 * 60 * 1000; // 24 h — effectively off

const IdleHandler = () => {
  const [showInactivityScreen, setShowInactivityScreen] = useState(false);
  const location = useLocation();
  const { currentuser } = useContext(AppContext);

  const isLoggedIn   = !!currentuser;
  const path         = location.pathname.toLowerCase();
  const isGuruRoute  = path.startsWith('/guru');
  const isKioskRoute = path.startsWith('/kiosk');

  // Timeout depends on authentication state
  let timeout;
  if (isLoggedIn) {
    timeout = SESSION_TIMEOUT;
  } else if (isGuruRoute || isKioskRoute) {
    timeout = SLIDESHOW_TIMEOUT;
  } else {
    timeout = DISABLED_TIMEOUT;
  }

  const handleOnIdle = () => {
    if (isLoggedIn) {
      // Session expired: clear session and redirect — no slideshow
      const role = currentuser?.roles?.[0];
      const isGuruUser  = currentuser?.organizationType?.toLowerCase() === 'truck';
      const isKioskUser = role === 'kiosk';

      setItemToStore('currentuser', null);
      setItemToStore('reportCompanyFilter', '');
      setItemToStore('reportPeriodType', 'day');
      setItemToStore('reportSelectedOrganizationId', 0);
      setItemToStore('reportSelectedOrganizationName', '');
      setItemToStore('reportExamResultFilter', '');

      if (isKioskUser) {
        window.location.href = '/kiosk/login';
      } else if (isGuruUser) {
        window.location.href = '/guru/login';
      } else {
        window.location.href = '/';
      }
    } else if (isGuruRoute || isKioskRoute) {
      // Guru/Kiosk login page idle: show screensaver/slideshow
      setShowInactivityScreen(true);
    }
  };

  useIdleTimer({
    timeout,
    onIdle: handleOnIdle,
    events: [
      'mousemove', 'keydown', 'mousedown', 'touchstart',
      'touchmove', 'wheel', 'scroll', 'click', 'focus',
    ],
  });

  if (showInactivityScreen) {
    return <InactivityScreen isKiosk={isKioskRoute} />;
  }

  return null;
};

export default IdleHandler;
